import React from 'react';
import moment from 'moment';
import serviceUrls from '../../../../constants/serviceUrls';
import uiHelpers from '../../../../helpers/uiHelpers';
import * as apiCaller from '../../../../helpers/apiCaller'
import { LoadingPage } from '../../../../components/tools/Others';
import SimActivationProcess from '../../../simActivationProcess/SimActivationProcess';
import { convertSimCardActivationProcessStatus } from '../../../../helpers/converters';

export default class MeterCommissionSimActivations  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            initialising:true
        };
        
    }

    async componentDidMount() {
        await this.refreshPage();
    }

    refreshPage = async () => {
        uiHelpers.showProgressOnTop('Please wait...');
        await apiCaller.post(serviceUrls.meterCommission.getSimActivations,{id:this.props.meterCommissionId})
        .then(this.wholePageDataBind).finally(()=>{
            uiHelpers.hideProgressOnTop();
        })
        ;
    }

    wholePageDataBind = (data, callback) =>{
        this.setState({
            processes:data.processes,
            initialising:false
        })
    }



    render() {
        if(this.state.initialising) return <LoadingPage />
        return <>
            <div class="table-responsive-xxl">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" style={{width:"220px"}}>Iccid</th>
                            <th scope="col" style={{width:"130px"}}>Status</th>
                            <th scope="col" style={{width:"200px"}}>Started Date</th>
                            <th scope="col" style={{width:"200px"}}>Completed Date</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.processes.map(h=>{

                            return <tr>
                                <td>{h.iccid}</td>
                                <td>{convertSimCardActivationProcessStatus(h.status)}</td>
                                <td>{moment((new Date(h.createdDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                <td>{h.completionDate && moment((new Date(h.completionDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                <td className='text-end'>
                                    <a className='btn btn-sm btn-primary' href={`/#/sim-activation-process/details/${h.id}`} target='_blank'>Open</a>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </>
    }
}